import * as faceapi from "face-api.js";

let modelLoaded = false;
let modelPromise = null;

export const loadFaceModel = async () => {
  if (modelLoaded) {
    return true;
  }

  if (!modelPromise) {
    modelPromise = faceapi.nets.tinyFaceDetector.loadFromUri("/static/models");
  }

  await modelPromise;

  const canvas = document.createElement("canvas");
  canvas.width = 10;
  canvas.height = 10;

  await faceapi.detectSingleFace(canvas, new faceapi.TinyFaceDetectorOptions());

  modelLoaded = true;

  console.log("Face Model Ready");

  return true;
};
